module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "hover": "",
      "raised": ""
    }
  }, [_c('v-card-media', {
    staticClass: "pa-5 red lighten-1",
    attrs: {
      "height": "300px"
    }
  }, [_c('div', {
    staticClass: "display-1 white--text text-xs-center"
  }, [_vm._v(_vm._s(_vm.msg))])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/vue-loader/lib/template-compiler?{"id":"data-v-01b3eca4","hasScoped":false}!/Users/gtirby/develop/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/404.vue
// module id = 411
// module chunks = 0